export default {
  "ORDER_WAIT_SHIP": "En attente d'expédition",
  "Men fashion": "Vêtements pour hommes",
  "MyAccount_MyProfile_label_First": "Prénom",
  "MyAccount_MyShippingDetails_Phone": "Numéro de téléphone",
  "Page_not_found_message1": "Désolé, la page que vous cherchez est introuvable",
  "Help": "Aidez-moi",
  "Sign in": "Connectez-vous",
  "Register": "S'inscrire",
  "Category_sorting_Item": "Choisir un mode de tri",
  "cart_clear": "Vider le panier",
  "Payment & Delivery": "Paiement et Livraison",
  "Send my feedback": "Envoyer mon avis",
  "MyAccount_MyProfile_Save": "Enregistrer les modifications",
  "Continue_billing": "Continuer à payer",
  "Categories": "Catégories",
  "Read and understand": "J'ai lu et compris",
  "Feel free to edit": "N'hésitez pas à modifier tous les détails de votre compte pour le maintenir à jour",
  "Select payment method": "Sélectionner le mode de paiement",
  "Login_input_email": "Votre email",
  "Login_input_first": "Prénom",
  "Account": "Compte",
  "Create_Time_Asc": "Ordre de création ascendant",
  "concactus_label": "Avis ou commentaire",
  "Order_Grade": "Note de la commande",
  "wishlist_empty_desc": "Il semble que vous n'ayez pas ajouté d'articles à votre panier. Commencez à magasiner et remplissez-le.",
  "cartpreviewShipping_messageinfo": "Vous recevrez une confirmation d'expédition et une date d'arrivée",
  "unsubscribe": "Vous pouvez vous désabonner à tout moment",
  "prompt": "Prompt",
  "MyAccount_MyProfile_yinsi_message": "Chez Brand name, nous attachons une grande importance à la confidentialité et nous nous engageons à protéger les données personnelles de nos utilisateurs. Pour en savoir plus sur la façon dont nous prenons soin et utilisons vos données personnelles, consu",
  "About us": "À propos de nous",
  "or": "Ou",
  "MyAccount_Order_History_All": "Toutes les commandes",
  "What_We_Improve": "Comment nous améliorer ?",
  "MyAccount_ShippingDetails_title": "Détails de la livraison",
  "MyAccount_Order_History_Tabs2": "En attente de paiement",
  "Go_back_shopping": "Retourner faire du shopping",
  "Product": "Produit",
  "Order summary": "Résumé de la commande",
  "payment_order_total": "Total de la commande",
  "Departments": "Déclarations légales",
  "Download": "Télécharger",
  "Your_Purchase_Order": "Votre commande",
  "Your_Account": "Votre compte",
  "order_after_sales_list_null": "Vous n'avez actuellement aucune commande après-vente",
  "All_After_sales_orders": "Toutes les commandes après-vente",
  "Filters": "Filtres",
  "search_results_not": "Nous n'avons trouvé aucun résultat associé à la phrase donnée",
  "ORDER_WAIT_RECEIPT": "En attente de réception",
  "ORDER_CLOSED": "Fermée",
  "Order_View_details": "Voir les détails",
  "Subscribe_to_message": "Soyez informé des prochaines ventes et événements. Recevez des cadeaux et des offres spéciales !",
  "TaxFee": "Frais de taxe",
  "Apply": "Appliquer",
  "Total_price": "Prix total",
  "Description": "Description",
  "Payment method": "Méthode de paiement",
  "Back": "Retour",
  "Empty": "Il semble que vous n'ayez pas ajouté d'articles à votre panier. Commencez à magasiner pour le remplir.",
  "After_sales": "Après-vente",
  "Instruction3": "Oui, nous le savons.",
  "MyAccount_MyShippingDetails_Last": "Nom",
  "MyAccount_MyShippingDetails_City": "Ville",
  "payment_order_discount": "Réduction de la commande",
  "MyAccount_Order": "Détails de la commande",
  "ID_Name_Error": "Veuillez entrer votre nom sur votre pièce d'identité",
  "Kidswear": "Vêtements pour enfants",
  "Share your look": "Partage ton look",
  "Pay_Order": "Payer la commande",
  "Reset_Password": "Réinitialiser le mot de passe",
  "MyAccount_MyProfile_label2_pass1": "Mot de passe actuel",
  "Create_Time_Desc": "Ordre de création descendant",
  "Items": "Articles",
  "Login_Register": "S'inscrire maintenant",
  "Back to homepage": "Retour à la page d'accueil",
  "switch_CNY": "Passer à CNY",
  "Successful placed order": "Votre commande a été réussie. Vous pouvez vérifier l'état de votre commande à l'aide de notre fonctionnalité de statut de livraison. Vous recevrez un e-mail de confirmation de commande contenant les détails de votre commande et un lien de suivi.",
  "MyAccount_MyProfile_yinsi_link": "Politique de confidentialité",
  "Order_Date": "Date de la commande",
  "Allow order notifications": "Permettre les notifications de commande",
  "MyAccount_MyProfile_Tab1": "Profil",
  "MyAccount_ShippingDetails_changeTitle": "Modifier l'adresse",
  "ID_Number": "Numéro d'identité",
  "Order_after_sales_message": "Détails et commandes après-vente",
  "MyAccount_MyProfile_title2": "Si vous souhaitez modifier le mot de passe pour accéder à votre compte, entrez les informations suivantes :",
  "Customer service": "Service client",
  "MyAccount_MyProfile_Update": "Mettre à jour le mot de passe",
  "choose_language": "Choisir la langue",
  "ORDER_REFUNDING": "Remboursement en cours",
  "MyAccount_MyProfile_title1": "N'hésitez pas à modifier les détails ci-dessous de votre compte pour le maintenir à jour",
  "ORDER_WAIT_RATE": "En attente des commentaires",
  "after_sales_refund_order": "Commande de remboursement",
  "Who we are": "Qui sommes-nous",
  "Women fashion": "Vêtements pour femmes",
  "Personal details": "Détails personnels",
  "Password": "Mot de passe",
  "wishlist_empty_title": "Votre panier est vide",
  "Repeat_Password": "Répéter le mot de passe",
  "cart_price": "Total",
  "Sort_by": "Trier par",
  "Customer Reviews": "Avis clients",
  "Continue to shipping": "Passer à la livraison",
  "payment_make_order": "Passer la commande",
  "save_order_review": "Enregistrer l'évaluation",
  "Save_Password": "Enregistrer le mot de passe",
  "cart_empty_title": "Votre panier est vide",
  "TopBar_help": "Aide et FAQ",
  "colseCookie": "J'ai compris",
  "Password_Changed": "Le mot de passe a été modifié avec succès. Vous pouvez maintenant retourner à la page d'accueil et vous connecter.",
  "Forgot Password Modal Email": "L'adresse email liée à votre compte:",
  "MyAccount_Personal": "Détails personnels",
  "cartPreviewShipping": "Livraison pratique",
  "ORDER_AFTER_SALE": "Après-vente",
  "Page_not_found": "Page non trouvée",
  "Find out more": "En savoir plus",
  "Log into your account": "Se connecter à votre compte",
  "Details_and_status_orders": "Consultez les détails et le statut de votre commande dans notre boutique en ligne. Vous pouvez également annuler ou retourner la commande.",
  "Order_to_be_paid_message": "En attente de paiement",
  "Guarantee": "Garantie",
  "Sections that interest you": "Sections qui vous intéressent",
  "payment_post_tax": "Taxe d'affranchissement",
  "ORDER_PAID": "Payé",
  "concactus_label5": "Civilité",
  "Item": "Article",
  "Go_back": "Retour",
  "more": "Plus",
  "MyAccount": "Mon compte",
  "payment_agree_1": "J'accepte",
  "total_items": "Total articles",
  "shopping_go": "Gérer les adresses de livraison",
  "ID_Type": "Type de pièce d'identité",
  "after_sales_status": "Statut après-vente",
  "After_sales_apply": "Appliquer l'après-vente",
  "Login": "Se connecter",
  "Quantity": "Quantité",
  "payment_post_fee": "Frais de port",
  "MyAccount_Log_out": "Se déconnecter",
  "Subtotal": "Sous-total",
  "forgotPasswordConfirmation": "Merci! Si vous avez enregistré un compte avec l'email {0}, vous trouverez un message contenant un lien de réinitialisation de mot de passe dans votre boite de réception.",
  "MyAccount_Order_History_Tabs1": "Mes commandes",
  "concactus_img": "Téléverser l'image",
  "Done": "Fini",
  "Info after order": "Vous pouvez vous connecter à votre compte avec l'email et le mot de passe que vous avez utilisé pour passer votre commande. Dans votre compte, vous pouvez modifier vos informations personnelles, vérifier l'historique des transactions, modifier les abonnem",
  "MyAccoubnt_Set_newsletter": "Configurez vos newsletters, nous vous enverrons chaque semaine de nouveaux produits et tendances dans les articles que vous avez sélectionnés.",
  "Shipping_method": "Mode de livraison",
  "after_sales_refund": "Montant du remboursement",
  "After_sales_save": "Enregistrer les informations après-vente",
  "go_order_history": "Voir l'historique des commandes",
  "contactus_message_placeholder": "Veuillez écrire votre commentaire ou votre question ici",
  "Login_Forgot_Password": "Si vous ne pouvez pas vous rappeler votre mot de passe, vous pouvez le réinitialiser.",
  "show_more": "Afficher plus",
  "MyAccount_MyProfile_label_email": "Votre adresse email",
  "MyAccount_MyProfile_label2_pass3": "Répétez le mot de passe",
  "Products": "Produits",
  "Review": "Commentaire",
  "MyAccount_MyProfile_title3": "Votre adresse email actuelle est",
  "Category_found_Products": "Produits trouvés",
  "Match": "Combinaison",
  "Read_all_reviews": "Lire tous les commentaires",
  "Commercial information": "Je consens également à recevoir des informations personnalisées sur les activités commerciales de Brand name par email",
  "Change password your account": "Si vous voulez changer le mot de passe pour accéder à votre compte, veuillez entrer les informations suivantes",
  "ID_Name": "Nom sur la pièce d'identité",
  "All": "Tout",
  "Instruction2": "Vous ne voulez que des instructions d'entretien?",
  "MyAccount_ShippingDetails_Add": "Ajouter une nouvelle adresse",
  "MyAccount_MyShippingDetails_Zip": "Code Postal",
  "go_pay_order": "Aller payer",
  "Thank_You_Inbox": "Si vous ne trouvez pas votre message dans votre boite de réception, essayez une autre adresse email que vous avez utilisée pour vous inscrire.",
  "Subscribe": "S'abonner",
  "confirm_subscription": "Je confirme l'abonnement",
  "Login_input_Remember": "Se souvenir de moi",
  "Add to compare": "Ajouter à la comparaison",
  "Brand": "Marque",
  "Start_shopping": "Commencer les achats",
  "Select shipping method": "Choisir le mode de livraison",
  "address CN": "Adresse en Chine, devise actuelle doit être RMB",
  "MyAccount_MyShippingDetails_State": "Région",
  "Page_not_found_message2": "Retourner ou essayer à nouveau",
  "Go_to_checkout": "Aller au paiement",
  "See all results": "Voir tous les résultats",
  "search_results_inputnull": "Vous n'avez pas recherché d'article.",
  "subscribeToNewsletterModalContent": "En vous abonnant à notre bulletin, vous recevrez des offres spéciales et des informations personnalisées de VSF par courrier électronique. Nous ne vendrons ni ne distribuerons jamais votre adresse électronique à des tiers. Consultez notre {0} pour plus d'",
  "Download all": "Tout Télécharger",
  "Login_input_last": "Nom de famille",
  "Amount": "Montant",
  "ORDER_WAIT_PAYMENT": "En attente de paiement",
  "Cookies Policy": "Politique en matière de cookies",
  "Clear all": "Vider tout",
  "Basket": "Panier",
  "MyAccount_MyProfile_reqeatPassErrMsg": "Les nouveaux mots de passe ne correspondent pas",
  "Your current email address is": "Votre adresse e-mail actuelle est",
  "You currently have no orders": "Vous n'avez actuellement aucune commande",
  "Login_input_password": "Mot de passe",
  "Order_After_sales": "Service après-vente de commande",
  "concattus_button": "Soumettre",
  "Shipping_valid_required": "Ce champ est obligatoire",
  "Price": "Prix",
  "ID_Type_Error": "Veuillez sélectionner le type de votre carte d'identité",
  "Order_Status": "Status de la commande",
  "Payment methods": "Méthodes de paiement",
  "MyAccount_MyProfile_Tab2": "Modifier le mot de passe",
  "Show on page": "Afficher sur la page",
  "Edit": "Modifier",
  "Change": "Changer",
  "MyAccount_ShippingDetails_Update": "Mettre à jour l'adresse",
  "View": "Voir",
  "Privacy": "Confidentialité",
  "Enter_promo_code": "Saisissez le code de promotion",
  "Discount": "Remise",
  "Delete": "Supprimer",
  "Wishlist": "Liste de souhaits",
  "MyAccount_Order_History_Tabs3": "Retour",
  "Go_To_Order_review": "Aller à la page d'évaluation",
  "Update personal data": "Mettre à jour les données personnelles",
  "payment_agree_2": "Conditions générales",
  "or fill the details below": "Ou remplissez les détails ci-dessous",
  "Contact details updated": "Mettez à jour votre adresse et vos coordonnées. ",
  "Login_Create": "Créer un compte",
  "Payment": "Paiement",
  "Billing": "Facturation",
  "payment_insurance_tax": "Assurance de la taxe",
  "Size guide": "Guide des tailles",
  "Login_forgotten_password": "Mot de passe oublié?",
  "Login_no_account": "Pas de compte?",
  "Privacy_Policy": "Politique de confidentialité",
  "BootomCookieTitle": "Autorisation des cookies",
  "Use your personal data": "Chez Brand name, nous accordons une grande importance à la confidentialité et nous nous engageons à protéger les données personnelles de nos utilisateurs. Pour en savoir plus sur la façon dont nous prenons soin et utilisons vos données personnelles, veuil",
  "Review my order": "Voir ma commande",
  "BootomCookieLink": "En savoir plus",
  "hide": "Masquer",
  "MyAccount_ShippingDetails_message_title": "Gérer toutes les adresses de livraison que vous souhaitez (lieu de travail, domicile, etc.) pour ne pas avoir à saisir manuellement l'adresse de livraison à chaque commande.",
  "Purchase terms": "Conditions d'achat",
  "Billing_address": "Adresse de facturation",
  "Manage shipping addresses": "Gérez toutes les adresses de livraison que vous souhaitez (lieu de travail, domicile, etc.) pour ne pas avoir à saisir manuellement l'adresse de livraison à chaque commande.",
  "login_logbtn": "Connexion",
  "choose_currency": "Choisissez la devise",
  "ORDER_REFUNDED": "Remboursé",
  "After_sales_form": "Remplissez le formulaire de service après-vente",
  "add_To_Wishlist": "Ajouter à la liste de souhaits",
  "search_results_inputnull2": "Commencez dès maintenant, nous vous aiderons. ",
  "Total": "Total",
  "Subscribe_to_newsletter": "S'abonner à la newsletter",
  "Shipping_valid_Phone": "Veuillez entrer un numéro de téléphone valide",
  "concactus_label3": "Titre",
  "Manage billing addresses": "Gérez toutes les adresses de facturation que vous souhaitez (lieu de travail, domicile, etc.) pour ne pas avoir à saisir manuellement l'adresse de facturation à chaque commande.",
  "Search_results_title": "Résultats de la recherche",
  "payment_order_payment": "Paiement de la commande",
  "after_sales_Id": "Identifiant de service après-vente",
  "cart_title": "Mon panier",
  "Order_Detail": "Détail de la commande",
  "concactus_label2": "Lien de la boutique",
  "Shipping_valid_length_min": "Ce champ doit contenir au moins {min} caractères",
  "Product suggestions": "Suggestions de produits",
  "Return_home": "Retour à la page d'accueil",
  "Quality in the details": "La qualité réside dans les détails",
  "Continue_to_payment": "Continuer le paiement",
  "Feedback": "Votre avis est important pour nous. Faites-nous savoir ce que nous pouvons améliorer.",
  "Go back to shop": "Retourner à la boutique",
  "Back_to_home": "Retourner à la page d'accueil",
  "Review_Content": "Contenu de l'évaluation",
  "add_To_Cart": "Ajouter au panier",
  "Read_reviews": "Lire les critiques",
  "Instruction1": "Instructions d'entretien",
  "Email_address": "Adresse e-mail",
  "Category_Item_List": "Changer la liste",
  "Same as shipping address": "Comme l'adresse de livraison",
  "Category_Item_Grid": "Changer la grille",
  "ID_Number_Error": "Veuillez saisir votre numéro d'identité",
  "concactus_label4": "E-mail de contact",
  "Additional_info": "Informations supplémentaires",
  "add_shipping": "Ajouter une nouvelle adresse de livraison",
  "Product_description": "Le Karissa V-Neck Tee est conçu pour être semi-ajusté, adapté à toutes les morphologies. Il épouse les courbes et cache les zones \"problématiques\" courantes pour vous permettre de vous entraîner en toute confiance à la salle de sport. Nous avons également",
  "Login_create_account": "Créer un compte",
  "after_sales_Reason": "Raison du SAV",
  "MyAccount_MyProfile_label_Last": "Nom de famille",
  "MyAccount_MyProfile_label2_pass2": "Nouveau mot de passe",
  "Save": "Enregistrer",
  "CartSliderTextBtn": "Enregistrer pour plus tard",
  "Color": "Couleur",
  "Shipping_Tax": "Taxe d'expédition",
  "Subscribe_to_success": "Abonnement réussi",
  "Enjoy your free account": "Profitez des avantages de votre compte gratuit!",
  "cart_empty_desc": "Il semble que vous n'ayez pas encore ajouté d'articles à votre panier. Commencez à magasiner pour le remplir.",
  "MyAccount_ShippingDetails_message_title2": "Maintenez votre adresse et vos coordonnées à jour. ",
  "An_error_occured": "Une erreur est survenue",
  "Country": "Pays",
  "MyAccount_MyShippingDetails_First": "Prénom",
  "payment_insurance_fee": "Frais d'assurance",
  "Home": "Accueil",
  "Contact_us": "Contactez-nous",
  "Promo_code": "Code promotionnel",
  "order_count": "Nombre de commandes",
  "email_geshi_error": "Veuillez saisir une adresse e-mail valide",
  "your_email": "Votre email",
  "email": "Email",
  "you_have_subscribed": "Vous êtes abonné",
  "cancel_Subscribe": "Annuler l'abonnement",
  "save_and_pay": "Enregistrer et payer",
  "hasInsurance": "Acheter une assurance",
  "pleasePayType": "Veuillez sélectionner le mode de paiement",
  "zhuanfa_toBePay": "Transférer à un ami pour effectuer le paiement pour vous",
  "linkCopied": "Lien copié. Collez-le et partagez-le avec vos amis",
  "Links": "Liens",
  "article_category": "Catégorie d'articles",
  "wechat_code_login_message": "Veuillez utiliser la numérisation du code QR de WeChat pour vous connecter",
  "wechat_code_login": "Connexion via la numérisation du code QR de WeChat",
  "Api_Update_success": "Mise à jour réussie",
  "Please_Use_WeChat_login": "Veuillez vous connecter via WeChat",
  "mobile_geshi_error": "Veuillez saisir un numéro de téléphone valide",
  "Login_input_email_required": "Veuillez entrer votre adresse e-mail",
  "article_null": "Aucun article disponible pour le moment",
  "Login_with_microsoft": "Se connecter avec Microsoft",
  "article_null_des": "Vous pouvez parcourir d'autres catégories d'articles",
  "register_email": "Inscription avec e-mail",
  "Login_tab_email": "Connexion avec e-mail",
  "code.time": "{time} secondes avant de pouvoir réessayer",
  "Login_with_wechat": "Se connecter avec WeChat",
  "cat_items_null_des": "Vous pouvez parcourir d'autres catégories de produits",
  "Login_with_facebook": "Se connecter avec Facebook",
  "Login_input_code": "Code de vérification",
  "Login_input_mobile_required": "Veuillez entrer votre numéro de téléphone",
  "Login_input_mobile": "Votre numéro de téléphone",
  "cat_items_null": "Aucun produit disponible dans cette catégorie",
  "Login_with_twitter": "Se connecter avec Twitter",
  "mobile_code": "Code de vérification",
  "register_mobile": "Inscription avec mobile",
  "Login_tab_mobile": "Connexion avec mobile",
  "Login_with_google": "Se connecter avec Google",
  "OrderSku": "Spécification des produits",
  "Order_logisticsNo": "Numéro de suivi",
  "order_shopping_firstname": "Prénom",
  "Order_logisticsName": "Compagnie de livraison",
  "ItemPrice": "Montant de la marchandise",
  "inPayOrderAll": "Liste des paiements en attente",
  "payPrice": "Montant payé",
  "shipping_add_success": "Adresse de livraison créée avec succès",
  "match_goods": "Produits populaires",
  "pay_code_refresh": "Actualiser le code de paiement",
  "pay_code_shixiao": "Le QR Code de paiement a expiré",
  "concactus_title": "Contactez-nous",
  "Search_items": "Recherche",
  "WebAutoLang": "Votre navigateur recommande actuellement la langue : {lang}, voulez-vous passer à cette langue ?",
  "Services_Name": "Nom du service",
  "Services_Price": "Coût du service",
  "SwichLang": "Changer de langue",
  "Services_Description": "Description du service",
  "goodinfo_null": "Aucun produit disponible",
  "goodinfo_null_des": "Vous pouvez parcourir les produits d'autres catégories",
  "notYetUseCode": "Code promotionnel non utilisé",
  "guest_Login": "Connexion des invités",
  "billing_and_shipping": "Facturation et livraison à la même adresse",
  "select_coupon": "Sélectionner le coupon",
  "select_gift": "Sélectionner le cadeau",
  "currentUseCode": "Code promotionnel utilisé",
  "shipping_refresh": "Actualiser la liste",
  "Shipping_details": "Adresse de livraison",
  "MyAccount_Newsletter": "Abonnement",
  "MyAccount_Profile": "Profil",
  "MyAccount_Wishlist": "Liste de souhaits",
  "See_all": "Tout",
  "MyAccount_History": "Historique des commandes",
  "bind_microsoft": "Lier Microsoft",
  "bind_twitter": "Lier Twitter",
  "bind_facebook": "Lier Facebook",
  "bind_wechat_code": "Code QR WeChat",
  "bind_wechat": "Lier WeChat",
  "bind_google": "Lier Google",
  "Wishlist_Empty": "Pas de liste de souhaits",
  "discount_post_fee": "Réduction sur les frais d'expédition",
  "ORDER_PART_PAID": "Paiement partiel",
  "claimCouponeSuccess": "Réussite de l'obtention de {name}",
  "discount_kou": "{discount} réduction",
  "claimCoupone": "Obtenir",
  "cartPreviewSafety_messageinfo": "Livraison sécurisée et rapide à votre adresse",
  "Order_No": "Numéro de commande",
  "cartPreviewSafety": "Livraison sûre",
  "Shipping": "Expédition",
  "MyAccount_MyShippingDetails_Street": "Rue",
  "MyAccount_MyShippingDetails_HouseNumber": "Numéro de maison",
  "Shipping_title": "Adresse de livraison",
  "Offline_payment": "Paiement hors ligne",
  "shopName": "Nom du magasin",
  "Social": "Social",
  "SERVICE": "Service",
  "onlineContact": "Contact en ligne",
  "confirm": "Confirmer",
  "closeOrder": "Annuler la commande",
  "closeOrderContext": "Êtes-vous sûr de vouloir annuler la commande ?",
  "Message_Read": "Lu",
  "close.order.success": "La commande a été annulée avec succès",
  "shippingAddress": "Adresse détaillée",
  "Message": "Message",
  "Message_Empty_Title": "Votre message est vide",
  "MyAccount_Message": "Message",
  "Message_Empty": "Aucun message",
  "payment_order_note": "Remarque de commande",
  "go_to_see_prepid": "Cliquez ici pour voir les commandes impayées",
  "operate": "opération",
  "removeCartItemContext": "Êtes-vous sûr de vouloir supprimer {title} ?",
  "shippingItemQty": "Quantité de livraison",
  "removeCartItem": "Supprimer l'article",
  "shippingInfo": "Informations de livraison",
  "Distributor_success": "A réussi à être un distributeur",
  "Distributor_apply": "S'appliquer pour être un distributeur",
  "Distributor_Details": "Distributeurs",
  "DistributorSataus": "Statut",
  "Distributor_Details_Empty": "Aucun distributeur pour le moment",
  "distributor.status.4": "Annulé",
  "distributor.status.1": "En attente d'approbation",
  "Distributor_copy_url": "Copier le lien de distribution",
  "Order_Time": "Heure de la commande",
  "Order_User": "Personne qui passe la commande",
  "Distributor_copy_success": "Copie réussie",
  "distributor.status.3": "Réglé",
  "MyAccount_Distributor": "Distributeurs",
  "MyAccoubnt_Set_Distributor": "S'appliquer pour être un distributeur",
  "distributor.status.2": "En attente de règlement",
  "DistributorAmount": "Commission",
  "Distributor_shenheshibai": "La vérification du distributeur a échoué",
  "Distributor_shenhezhong": "Examen du distributeur en cours",
  "Distributor_Order_Empty": "Pas de commande de distribution pour le moment",
  "NE": "Niger",
  "DJ": "Djibouti",
  "KP": "Corée du Nord",
  "US": "États-Unis",
  "LC": "Sainte-Lucie",
  "NL": "Pays-Bas",
  "CD": "République démocratique du Congo",
  "IS": "Islande",
  "MA": "Maroc",
  "GH": "Ghana",
  "KR": "Corée du Sud",
  "MK": "Macédoine",
  "HT": "Haïti",
  "PF": "Polynésie française",
  "GA": "Gabon",
  "TD": "Tchad",
  "LB": "Liban",
  "CG": "République du Congo",
  "KG": "Kirghizistan",
  "TA": "Tristão da Cunha",
  "KW": "Koweit",
  "TL": "Timor-Leste",
  "IN": "Inde",
  "NO": "Norvège",
  "NG": "Nigeria",
  "AQ": "Antarctique",
  "LY": "Libye",
  "NI": "Nicaragua",
  "TT": "Trinité-et-Tobago",
  "HM": "Îles Heard-et-MacDonald",
  "PY": "Paraguay",
  "BA": "Bosnie-Herzégovine",
  "JP": "Japon",
  "MD": "Moldavie",
  "MT": "Malte",
  "RE": "La Réunion",
  "UG": "Ouganda",
  "SB": "Îles Salomon",
  "SL": "Sierra Leone",
  "CV": "Cap-Vert",
  "SD": "Soudan",
  "FO": "Îles Féroé",
  "ZA": "Afrique du Sud",
  "TR": "Turquie",
  "FK": "Îles Malouines",
  "PA": "Panamá",
  "GF": "Guyane française",
  "TJ": "Tadjikistan",
  "NC": "Nouvelle-Calédonie",
  "PM": "Saint-Pierre-et-Miquelon",
  "NU": "Niue",
  "AO": "Angola",
  "VN": "Viêt Nam",
  "GN": "Guinée",
  "MW": "Malawi",
  "BY": "Bélarus",
  "IM": "Île de Man",
  "BI": "Burundi",
  "BS": "Bahamas",
  "CK": "Îles Cook",
  "MH": "Îles Marshall",
  "CR": "Costa Rica",
  "HK": "R.A.S. chinoise de Hong Kong",
  "AD": "Andorre",
  "BN": "Brunei Darussalam",
  "SN": "Sénégal",
  "AE": "Émirats arabes unis",
  "GI": "Gibraltar",
  "CA": "Canada",
  "AX": "Îles Åland",
  "UY": "Uruguay",
  "WF": "Wallis-et-Futuna",
  "GM": "Gambie",
  "SO": "Somalie",
  "RU": "Russie",
  "PL": "Pologne",
  "FM": "Micronésie",
  "ET": "Éthiopie",
  "EE": "Estonie",
  "SK": "Slovaquie",
  "AS": "Samoa américaines",
  "ZM": "Zambie",
  "AL": "Albanie",
  "AT": "Autriche",
  "VA": "Vatican",
  "TW": "Taïwan",
  "BD": "Bangladesh",
  "AR": "Argentine",
  "EH": "Sahara occidental",
  "MO": "Macao SAR de Chine",
  "MV": "Maldives",
  "GU": "Guam",
  "AW": "Aruba",
  "AI": "Anguilla",
  "CL": "Chili",
  "IL": "Israël",
  "GD": "Grenade",
  "WS": "Samoa",
  "SE": "Suède",
  "GP": "Guadeloupe",
  "YE": "Yémen",
  "GT": "Guatemala",
  "BG": "Bulgarie",
  "SJ": "Svalbard et Jan Mayen",
  "CO": "Colombie",
  "LS": "Lesotho",
  "LV": "Lettonie",
  "UM": "Îles mineures éloignées des États-Unis",
  "MX": "Mexique",
  "DO": "République dominicaine",
  "PE": "Pérou",
  "HN": "Honduras",
  "TC": "Îles Turks et Caïques",
  "VI": "Îles Vierges américaines",
  "FJ": "Fiji",
  "MP": "Îles Mariannes du Nord",
  "AC": "Île de l'Ascension",
  "NA": "Namibie",
  "SZ": "Swaziland",
  "RW": "Rwanda",
  "BH": "Bahreïn",
  "KN": "Saint-Kitts-et-Nevis",
  "TN": "Tunisie",
  "AF": "Afghanistan",
  "VG": "Îles Vierges britanniques",
  "KE": "Kenya",
  "PK": "Pakistan",
  "GL": "Groenland",
  "SY": "Syrie",
  "CU": "Cuba",
  "RS": "Serbie",
  "BF": "Burkina Faso",
  "BM": "Bermudes",
  "BZ": "Belize",
  "SV": "Salvador",
  "CN": "Chine",
  "MF": "Saint-Martin",
  "NF": "île Norfolk",
  "MZ": "Mozambique",
  "LU": "Luxembourg",
  "TO": "Tonga",
  "GR": "Grèce",
  "SI": "Slovénie",
  "PW": "Palaos",
  "TZ": "Tanzanie",
  "IR": "Iran",
  "GG": "Guernesey",
  "SM": "Saint-Marin",
  "TF": "Terres australes françaises",
  "PS": "Palestine",
  "SC": "Seychelles",
  "BT": "Bhoutan",
  "JM": "Jamaïque",
  "BR": "Brésil",
  "CH": "Suisse",
  "SH": "Sainte-Hélène",
  "HU": "Hongrie",
  "TM": "Turkménistan",
  "LT": "Lituanie",
  "MC": "Monaco",
  "LI": "Liechtenstein",
  "LR": "Liberia",
  "GE": "Géorgie",
  "SA": "Arabie saoudite",
  "GB": "Royaume-Uni",
  "VE": "Venezuela",
  "MU": "Maurice",
  "HR": "Croatie",
  "SR": "Suriname",
  "CM": "Cameroun",
  "IQ": "Irak",
  "BO": "Bolivie",
  "MN": "Mongolie",
  "DZ": "Algérie",
  "TK": "Tokelau",
  "MG": "Madagascar",
  "YT": "Mayotte",
  "CC": "Cocos (Keeling) Islands",
  "LA": "Laos",
  "PT": "Portugal",
  "QA": "Qatar",
  "AN": "Netherlands Antilles",
  "PN": "Pitcairn Islands",
  "ES": "Spain",
  "VC": "Saint Vincent and the Grenadines",
  "AU": "Australia",
  "CX": "Christmas Island",
  "KM": "Comoros",
  "MR": "Mauritania",
  "FR": "France",
  "SG": "Singapore",
  "BV": "Bouvet Island",
  "PH": "Philippines",
  "CY": "Cyprus",
  "TV": "Tuvalu",
  "CF": "Central African Republic",
  "EC": "Ecuador",
  "GW": "Guinea-Bissau",
  "IE": "Ireland",
  "LK": "Sri Lanka",
  "ER": "Eritrea",
  "GQ": "Equatorial Guinea",
  "NP": "Nepal",
  "BE": "Belgium",
  "GY": "Guyana",
  "DK": "Denmark",
  "MQ": "Martinique",
  "UZ": "Uzbekistan",
  "CI": "Ivory Coast",
  "ID": "Indonesia",
  "BJ": "Benin",
  "ST": "São Tomé and Príncipe",
  "KH": "Cambodia",
  "KZ": "Kazakhstan",
  "MS": "Montserrat",
  "TH": "Thailand",
  "FI": "Finland",
  "ML": "Mali",
  "AM": "Armenia",
  "IT": "Italy",
  "NR": "Nauru",
  "PG": "Papua New Guinea",
  "ZW": "Zimbabwe",
  "JO": "Jordan",
  "OM": "Oman",
  "ME": "Monténégro",
  "JE": "Jersey",
  "NZ": "Nouvelle-Zélande",
  "VU": "Vanuatu",
  "DE": "Allemagne",
  "CZ": "République Tchèque",
  "DM": "Dominique",
  "KY": "Îles Caïmans",
  "BW": "Botswana",
  "RO": "Roumanie",
  "PR": "Porto Rico",
  "AZ": "Azerbaïdjan",
  "IO": "Territoire britannique de l'océan Indien",
  "UA": "Ukraine",
  "TG": "Togo",
  "MY": "Malaisie",
  "AG": "Antigua-et-Barbuda",
  "EG": "Égypte",
  "GS": "Géorgie du Sud et les îles Sandwich du Sud",
  "MM": "Myanmar",
  "BB": "Barbade",
  "KI": "Kiribati",
  "All_Country": "tous",
  "post_state_country": "Frais de livraison : {country} {state} {postFee}",
  "zhichiDeliveryCountry": "Livrer à",
  "ShippingFee": "Frais de livraison",
  "reviewOutOf": "{rating} étoiles sur 5",
  "product.pifa.label": "Achetez de {startnum} à {endnum} articles",
  "product.pifa.type.1": "Remise",
  "Write_a_review": "Écrire un commentaire",
  "BasedOnTotalReviews": "Basé sur {total} commentaires",
  "product.wholesale": "Prix de gros",
  "reviewMostRecent": "Commentaires les plus récents",
  "product.pifa.type.2": "Prix unitaire",
  "product.num.danwei": "unité",
  "good.shoppingDateLabel": "Date d'expédition",
  "good.shippingPeriod": "Expédié dans les jours",
  "emailError": "Format de l'e-mail incorrect",
  "addressNote": "Remarque sur l'adresse",
  "Concactus": "Contactez-nous",
  "addressMessage": "Veuillez vous assurer que votre adresse est correcte. Après le paiement, nous ne pouvons plus modifier l'adresse.",
  "showOrderSummary": "Résumé de la commande",
  "payment_method": "Mode de paiement",
  "emailNotNullError": "L'email ne peut pas être vide",
  "orderCreateLoading": "Création de commande en cours...",
  "emailNote": "Contactez-nous",
  "emailMessage": "Veuillez vous assurer que votre adresse e-mail est correcte. Nous vous enverrons un e-mail de confirmation de commande.",
  "payment_method_message": "Toutes les transactions sont sécurisées et cryptées.",
  "go_buy_goods": "Continuer vos achats",
  "tap_cancel_order": "Cliquez ici pour annuler la commande",
  "order_review": "évaluation de commande",
  "Add_new_address": "Ajouter une nouvelle adresse",
  "promo_code_type_3": "Coupon-cadeau",
  "IdCardNotNull": "Veuillez fournir des informations réelles",
  "UploadVideo": "Télécharger la vidéo",
  "video": "Vidéo",
  "UploadImage": "Télécharger l'image",
  "uploadImageing": "Téléchargement en cours...",
  "BillingInfoNotNull": "Informations de facturation incomplètes",
  "promo_code_type_2": "Chèque-cadeau",
  "UploadError": "Erreur de téléchargement",
  "promo_code_type_4": "Bel coupon de Réduction des Frais de livraison",
  "image": "Image",
  "paymentMethodNotNull": "Veuillez sélectionner un mode de paiement",
  "promo_code_type_1": "Coupon de Réduction",
  "shippingInfoNotNull": "Informations de livraison incomplètes",
  "reviewDetail": "Détails de l'évaluation",
  "DeliveryCountry": "Zone de livraison",
  "prompt_error": "Erreur de prompt",
  "save_review_success": "Commentaire enregistré avec succès",
  "ORDER_COMPLETED": "Terminé",
  "crate_after_sales": "Créer un service après-vente",
  "Thank_You_Order": "Merci pour votre commande !",
  "Thank_You_Order_sub": "Nous commencerons bientôt à traiter votre commande et vous recevrez un e-mail contenant des informations sur le traitement de votre commande.",
  "BootomCookieContext": "Ce site utilise des cookies pour aider le site à fonctionner correctement et nous permettre de comprendre comment interagir avec lui. Nous utilisons ces cookies pour vous offrir une meilleure expérience utilisateur personnalisée. Si vous continuez à utili",
  "order_reivice_message": "Êtes-vous sûr d'avoir reçu la marchandise ?",
  "order_reivice_btn": "Confirmer la réception",
  "order_reivice_label": "Réception de la commande",
  "order_reivice_success": "Confirmation de la réception réussie",
  "collpase_show": "Voir plus",
  "collpase_hide": "Réduire",
  "CouponCode": "Code promotionnel",
  "wechatPayScannerCode": "Veuillez utiliser WeChat pour scanner le code de paiement",
  "processing": "Traitement après-vente",
  "finished": "Après-vente terminé",
  "login.showPrice": "Voir le prix après connexion",
  "After_Sales_Unknown": "État après-vente inconnu",
  "order_payment_list_null": "Aucune commande en attente de paiement",
  "Cancel": "Annuler",
  "thankyou_concat": "Si vous avez des questions, veuillez nous contacter"
}